import { connect } from 'react-redux';
import { Constants } from '@shared/utils/constants';
import { createClearCheckoutState, createSetItemInCartAction } from '@shared/actions/checkoutActions';
import { changeBillingRegion, getAppPricing, getCustomers, updateCustomer, createCustomer, ensureAppDetailsData } from '@shared/actions/thunkActions';
import { Checkout as CheckoutComponent } from '@appsource/components/checkout';
import { createSetIsDisabledBilling, createModalAction } from '@shared/actions/actions';
import { withRouter } from '@shared/routerHistory';
import { isProfessionalService as checkIsProfessionalService } from '@shared/utils/appUtils';
const mapStateToProps = (state, ownProps)=>{
    const { checkout, checkout: { checkoutId }, users: userInfo, config: { correlationId, currentView, billingCountryCode, locale, featureFlags } } = state;
    const targetApp = [
        ...state.apps.dataList,
        ...state.cloudsIndustry.dataList,
        ...state.services.dataList
    ].find((offer)=>(offer === null || offer === void 0 ? void 0 : offer.entityId.toString().toLowerCase()) === ownProps.routeParams.entityId.toString().toLowerCase());
    const isProfessionalService = (targetApp === null || targetApp === void 0 ? void 0 : targetApp.entityType) === Constants.EntityType.Service && checkIsProfessionalService({
        service: targetApp
    });
    return {
        app: targetApp,
        checkout,
        userInfo,
        correlationId,
        currentView,
        billingCountryCode,
        locale,
        location: ownProps.location,
        featureFlags,
        isProfessionalService,
        checkoutId
    };
};
const mapDispatchToProps = (dispatch)=>{
    return {
        setIsDisabledBilling: (disabled)=>dispatch(createSetIsDisabledBilling(disabled)),
        setCartItem: (cartItem)=>dispatch(createSetItemInCartAction(cartItem)),
        updateCustomer: (address)=>dispatch(updateCustomer(address)),
        fetchPricing: (entityId, isPrivate, market)=>isPrivate ? dispatch(ensureAppDetailsData(entityId, true, market)) : dispatch(getAppPricing(entityId, market)),
        clearCheckoutState: ()=>dispatch(createClearCheckoutState({})),
        setBillingCountry: (countryCode)=>{
            const countryCodeValue = countryCode === null || countryCode === void 0 ? void 0 : countryCode.toLowerCase();
            return dispatch(changeBillingRegion(countryCodeValue));
        },
        createCustomer: ()=>dispatch(createCustomer()),
        getCustomers: ()=>dispatch(getCustomers()),
        openModal: ({ modalId, disableDismissModal, onModalDismiss })=>dispatch(createModalAction({
                showModal: true,
                modalId,
                disableDismissModal,
                onModalDismiss
            }))
    };
};
const Checkout = withRouter(connect(mapStateToProps, mapDispatchToProps)(CheckoutComponent));
export default Checkout;
